// External libraries
import React from 'react';
import { func, object } from 'prop-types';
import { ErrorIcon } from '@checkout/react-components';

// Internal Modules
import {
  ErrorContainer,
  ErrorMessage,
} from '@/components/CRSFields/StyledComponents';
import { getContent } from '@/lib';
import {
  DOES_NOT_PAY_TAXES_OUTSIDE_COUNTRY,
  PAYS_TAXES_OUTSIDE_COUNTRY,
} from '@/components/CRSFields/constants';
import { crsResidencyStatusChangeHandler } from './handlers';
import { RadioButton, SubHeading } from '../../Common';

const CRSTaxResidencyStatusRadioButtons = ({ crsTaxStatus, dispatch }) => {
  const { value, displayError, error } = crsTaxStatus;
  const changeHandler = ev =>
    crsResidencyStatusChangeHandler(ev, dispatch, crsTaxStatus);

  return (
    <>
      <SubHeading>{getContent('crs.taxResidency.title')}</SubHeading>

      <RadioButton
        changeHandler={changeHandler}
        checked={value === DOES_NOT_PAY_TAXES_OUTSIDE_COUNTRY}
        hasError={displayError}
        id={DOES_NOT_PAY_TAXES_OUTSIDE_COUNTRY}
        label={getContent('crs.taxResidency.currentCountryTaxResident')}
        labelFontSize="18px"
        name="crsTaxStatus"
        radioButtonContainerMargin="1rem 0"
        value={DOES_NOT_PAY_TAXES_OUTSIDE_COUNTRY}
      />

      <RadioButton
        changeHandler={changeHandler}
        checked={value === PAYS_TAXES_OUTSIDE_COUNTRY}
        hasError={displayError}
        id={PAYS_TAXES_OUTSIDE_COUNTRY}
        label={getContent('crs.taxResidency.foreignTaxResident')}
        labelFontSize="18px"
        name="crsTaxStatus"
        value={PAYS_TAXES_OUTSIDE_COUNTRY}
      />

      {displayError && (
        <ErrorContainer data-testid="error-container">
          <ErrorIcon />
          <ErrorMessage>{error}</ErrorMessage>
        </ErrorContainer>
      )}
    </>
  );
};

CRSTaxResidencyStatusRadioButtons.propTypes = {
  crsTaxStatus: object,
  dispatch: func,
};

export { CRSTaxResidencyStatusRadioButtons };
